import React from "react";
import { useEffect } from "react";
import Footer from "../components/footer";
import NavbarHome from "../components/navbar-home";
import HeaderSatuContent from "../pages/Features/header-satu-content";
import HeaderSatuJumbotron from "../pages/Features/header-satu-jumbotron";

export default function FeatureHeaderSatu() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <>
    <NavbarHome />
    <HeaderSatuJumbotron />
    <HeaderSatuContent />
    <Footer />
    </>
  );
}
